import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StudyDicomInfo, Study, HorseStudyAcknowledgmentsDto, StudyDraftSubmissionAcknowledgementsRequestDto } from '../../../../models/Study/study.model';
import { BaseUnsubscribeComponent } from '../../../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { DateParserFormatter } from '../../../../utils/helper/date-parser-formatter';

@Component({
  selector: 'app-clinical-study-sumbission-acknowledgments-popup',
  templateUrl: './clinical-study-sumbission-acknowledgments-popup.component.html',
  styleUrls: ['./clinical-study-sumbission-acknowledgments-popup.component.scss']
})
export class ClinicalStudySumbissionAcknowledgmentsPopupComponent extends BaseUnsubscribeComponent implements OnInit {
  @Input() public lotOrHipText: string = '';
  public dateFormat: string = '';
  @Input() public acknowledgments: HorseStudyAcknowledgmentsDto;
  public isLotHasXrayImagesSubmittedAcknowledged: boolean = false;
  public isLotHasScopeVideoSubmittedAcknowledged: boolean = false;
  public isStudyUploadedToDifferentLotAcknowledged: boolean = false;
  @Input() public study: Study;
  @Input() public set catalogDataSource(value: StudyDicomInfo[]) {
    const horseInfo = value.filter(x => x.type === "Repo");
    if (horseInfo && horseInfo.length > 0) {
      this.catalogData = horseInfo[0];
    }
  }
  public catalogData: StudyDicomInfo;
  constructor(public modal: NgbActiveModal, private dateParserFormatter: DateParserFormatter) {
    super();
  }

  get isConfirmDisabled(): boolean {
    const acknowledgments = this.acknowledgments?.draftAcknowledgments;

    if (this.acknowledgments?.mediaConversionErrors?.length > 0) {
      return true;
    }

    if (!acknowledgments) {
      return false; // no warnings => button enabled
    }

    if (acknowledgments.isLotHasXrayImagesSubmitted && !this.isLotHasXrayImagesSubmittedAcknowledged) {
      return true;
    }
    if (acknowledgments.isLotHasScopeVideoSubmitted && !this.isLotHasScopeVideoSubmittedAcknowledged) {
      return true;
    }
    if (acknowledgments.isStudyUploadedToDifferentLot && !this.isStudyUploadedToDifferentLotAcknowledged) {
      return true;
    }

    return false;
  }

  get isAcknowledgementsSectionEnabled(): boolean {
    const acknowledgments = this.acknowledgments;
    return acknowledgments?.draftAcknowledgments?.isLotHasXrayImagesSubmitted || 
      acknowledgments?.draftAcknowledgments?.isLotHasScopeVideoSubmitted || 
      acknowledgments?.draftAcknowledgments?.isStudyUploadedToDifferentLot || 
      acknowledgments?.mediaConversionErrors?.length > 0;
  }

  OnConfirmation(): void {
    var result = {
      confirmation: 'confirm',
      acknowledgementData: {
        isLotHasXrayImagesSubmittedAcknowledged: this.isLotHasXrayImagesSubmittedAcknowledged,
        isLotHasScopeVideoSubmittedAcknowledged: this.isLotHasScopeVideoSubmittedAcknowledged,
        isStudyUploadedToDifferentLotAcknowledged: this.isStudyUploadedToDifferentLotAcknowledged
      } as StudyDraftSubmissionAcknowledgementsRequestDto
    };
    this.modal.close(result);
  }
  ngOnInit(): void {
    this.dateParserFormatter.setIsUSTimeZone(this.lotOrHipText);
    this.dateFormat = this.dateParserFormatter.getLongDateTimeFormat();
  }

}
